import { useEffect, useRef } from "react";
import AMapLoader from "@amap/amap-jsapi-loader";

import "./MapPicker.scss";
import { MapPickerWrapper } from "./MapPicker.styled";

interface MapPickerProps {
    lng?: number;
    lat?: number;
    pickAddress?: boolean;
    onPick: (lng: number, lat: number, address?: string)=> void;
    onMapInit?: (amapType: any, amap: any)=> void;

}

const MapPicker: React.FC<MapPickerProps> = (props)=> {
    // ref
    let aMapContainerRef = useRef(null as any);
    let aMapTypeRef = useRef(null as any);
    let amapRef = useRef(null as any);
    let locaContextRef = useRef({loca: null, pulseLinkLayer: null} as any);
    let markerRef = useRef(null as any);

    // functions
    let initializeMap = (dom: HTMLElement)=> {
        AMapLoader.load({
            "key": "0c3d07d8ebae700b5652bbfc2cf18fb0", 
            "version": "2.0",
            "plugins": [],
        }).then((AMap)=>{
            if (dom == null || aMapContainerRef.current == dom) {
                return;
            }

            let propsHasLngLat = props.lng != null && props.lat != null;
            const amap = new AMap.Map(dom, {
                pitchEnable: false,
                zoom: 5,
                zooms:[5,20],
                pitch: 25,
                center: propsHasLngLat ? [props.lng, props.lat] : [112.070696, 29.752075],
                mapStyle: "amap://styles/blue",
                viewMode: "3D",
            });
            aMapContainerRef.current = dom;
            aMapTypeRef.current = AMap;
            amapRef.current = amap;
            amap.on('click', onMapClick);
            amap.zoomTo = zoomTo;

            // zoom to given lng and lat
            if (propsHasLngLat) {
                zoomTo(props.lng, props.lat);
            }

            // notify map inited
            if (props.onMapInit) {
                props.onMapInit(AMap, amap);
            }
        }).catch((e)=> {
            console.log(e);
        });
    };

    // events
    let onMapClick = (e: any)=> {
        let lnglat = e.lnglat;
        zoomTo(lnglat.getLng(), lnglat.getLat());
        if (props.pickAddress) {
            let AMap = aMapTypeRef.current;
            AMap.plugin('AMap.Geocoder', function() {
                var geocoder = new AMap.Geocoder();
                geocoder.getAddress(lnglat, function(status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        var address = result.regeocode.formatted_address;
                        console.log("您点击的位置地址为：" + address);
                        props.onPick(lnglat.getLng(), lnglat.getLat(), result.regeocode.formatted_address);
                    }
                });
            });
        } else {
            props.onPick(lnglat.getLng(), lnglat.getLat());
        }
    };

    let zoomTo = (lng: number, lat: number)=> {
        if (amapRef.current) {
            let amap = amapRef.current;
            amap.setZoomAndCenter(15, [lng, lat], false, 500);
        }

        let marker = markerRef.current;
        if (marker == null) {
            marker = new AMap.Marker({
                position: [lng, lat],
                content: `<div class="online-circle">
                    <div class="waves" style="animation: wave ease-out infinite 2s 0s"></div>
                    <div class="waves" style="animation: wave ease-out infinite 2s 0.3s"></div>
                    <div class="waves" style="animation: wave ease-out infinite 2s 0.6s"></div>
                </div>`,
                offset: new AMap.Pixel(-5, -5),
                cursor: 'pointer',
            });
            marker.setMap(amapRef.current);
            markerRef.current = marker;
        }
        marker.setPosition([lng, lat]);
    };

    // onload
    useEffect(()=> {
        return ()=> {
            locaContextRef.current?.loca?.destroy();
            amapRef.current?.destroy();
        }
    }, []);

    useEffect(()=> {
        if (amapRef.current) {
            let amap = amapRef.current;
            amap.setZoomAndCenter(11, [props.lng, props.lat], false, 500);
        }
    }, [props.lat, props.lng]);

    // render
    return <MapPickerWrapper>
        <div id="map-container" style={{width: "100%", height: "100%"}} ref={(dom)=> initializeMap(dom)}>
        </div>
    </MapPickerWrapper>;
};

export default MapPicker;

